/* Add ProjectBusinessInsights, Projects Debriefs, Type to  Jan 25, 2022 */
/* Add New columns streetAddress, city, zipCode, StateProvince, workInPlace, daysToCompletion, m_getProjectNo, m_checkProjectNo Jan 25, 2022 */
/* Amend bug use c_validProjectNo, c_projectNoToolTip, change ProjeciId to projectId Mar 13, 2022 */
/* Add Decimal correction Jan 21, 2023 */
/* Add KT-ProjectDebrief.vue Jul 17, 2023 */
/* Add CustomFields Aug 5, 2023 */
/* Add kt-notes,d_savedRecord Feb 17, 2024 */
/* Add m_processVoice June 1,2024 */
/* Add p_mode to custom-field Aug 24, 2024 */
/* Add  readonly, required columns Jan 25, 2025 */
/* Add required indicator Feb 15, 2025 */
/* Remove Notes May 30, 2025 */
/* Amend Photo June 21, 2025 */
/* GUI changes Phase1  May 15, 2026 */
<template lang="pug">
	div
		rec-wrap(ref="rec-wrap" :p_mode="p_mode" :p_saveFn="m_saveFn" p_appEntKey="proj" :p_isModal="p_isModal" p_enableClone=true
			:p_requiredColumns="d_requiredColumns" :p_recData="d_recData" :p_rmndOpt="d_rmndOpt" :p_altView="d_altViewKey" @altViewChg="d_altViewKey = $event"  @focused="d_currentFocus = $event" @voice="m_processVoice")
			template(v-slot:rec-form-header)
				div(class="d-flex raisedHeader")
					div(class="form-group"  style="text-align:left;width:33%")
						kt-photo(id="projectPhoto" ref="kt-photo" p_prntRecKey="proj" :p_recInfo="c_recInfo" :p_photoRec="c_photoRec")
					div(style="width:33%;")
						kt-progress-status(id="progressStatus"  p_entity="proj" p_title="Project Progress" :p_statusId="d_recData.projectStatusId" :p_statuses="c_statuses")
					div(class="milestoneClass")
						<span class="d-block"><span class="blueLabel">Project Value:</span><span class="dataHighlight">{{c_value}}</span></span> 
						<span class="d-block"><span class="blueLabel">Construction Start Date:</span><span class="dataHighlight">{{c_startDate}}</span></span>
						<span class="d-block"><span class="blueLabel">Construction Completion Date:</span><span class="dataHighlight">{{c_completionDate}}</span></span> 
			template(v-slot:rec-form-left)
				span <span style="color:#ff9333;">*</span>indicates field is required.
				div(class="form-group")
					label(class="required-label") Project #
					b-form-input(size="sm" id="projectNo" v-model="d_recData.projectNo" maxlength=50 :state="c_validProjectNo" v-b-tooltip trigger="click hover focus" :title="c_projectNoToolTip"  required @change="m_checkProjectNo($event)"  )
				div(class="form-group")
					label(class="required-label") Project Name
					b-form-input(class="styled-input" size="sm" id="projectName" v-model="d_recData.projectName" maxlength=100 required)
				div(class="form-group")
					label Site Address
					kt-address(id="siteAddress" :p_recData="d_recData" :p_readOnly="p_mode=='view'" p_appEntKey='proj')
				div(class="form-group")
					label(:class="m_required('clientAccountId')?'required-label':''") Client
					kt-select(
						p_appEntKey="acct"
						id="clientAccountId"
						:p_currentVal="d_recData.clientAccount"
						:p_readOnly="p_mode=='view'||m_readOnly('clientAccountId')"
						:p_enableCreate="true"
						@change="d_recData.clientAccount = $event; d_recData.clientAccountId = ($event||{}).accountId||null;"
					
					)
				div(class="form-group")
					label(:class="m_required('clientAccounts')?'required-label':''") Additional Client(s)
					kt-list(
						p_appEntKey="acct"
						id="clientAccounts"
						:p_currentVals="d_recData.clientAccounts"
						:p_readOnly="p_mode=='view'||m_readOnly('clientAccounts')"
						:p_enableCreate="true"
						:p_enableAdd="true"
						@change="d_recData.clientAccounts = $event"
		
					)
				div(class="form-group")
					label(:class="m_required('primaryClientAccountContactId')?'required-label':''") Primary Client Contact
					kt-select(
						p_appEntKey="extr"
						id="primaryClientAccountContactId"
						:p_currentVal="d_recData.primaryClientAccountContact"
						:p_readOnly="p_mode=='view'||m_readOnly('primaryClientAccountContactId')"
						:p_enableCreate="true"
						:p_filterFirstKey="d_recData.clientAccountId"
						@change="d_recData.primaryClientAccountContact = $event; d_recData.primaryClientAccountContactId = ($event||{}).externalContactId||null;"
					)
				div(class="form-group")
					label(:class="m_required('designerAccounts')?'required-label':''") Designer(s)
					kt-list(
						p_appEntKey="acct"
						id="designerAccounts"
						:p_currentVals="d_recData.designerAccounts"
						:p_readOnly="p_mode=='view'||m_readOnly('designerAccounts')"
						:p_enableCreate="true"
						:p_enableAdd="true"
						@change="d_recData.designerAccounts = $event"
						
					)
				div(class="form-group")
					label(:class="m_required('internalContactId')?'required-label':''") Internal Contact
					kt-select(
						p_appEntKey="team"
						id="internalContactId"
						:p_currentVal="d_recData.internalContact"
						:p_readOnly="p_mode=='view'||m_readOnly('internalContactId')"
						:p_enableCreate="true"
						@change="d_recData.internalContact = $event; d_recData.internalContactId = ($event||{}).teamMemberId||null;"
						
					)
				div(class="form-group")
					label(:class="m_required('assignedTeamMembers')?'required-label':''") Assigned Team Member(s)
					kt-list(
						p_appEntKey="team"
						id="assignedTeamMembers"
						:p_currentVals="d_recData.assignedTeamMembers"
						:p_readOnly="p_mode=='view'||m_readOnly('assignedTeamMembers')"
						:p_enableCreate="true"
						:p_enableAdd="true"
						@change="d_recData.assignedTeamMembers = $event"
						
					)
			template(v-slot:rec-form-right)
				div(class="form-group")
					label(:class="m_required('opportunity')?'required-label':''") Opportunity Name
					kt-select(
						p_appEntKey="oppr"
						id="opportunity"
						ref="projRec_opportunity"
						:p_currentVal="d_recData.opportunity"
						:p_readOnly="p_mode == 'create'? false : true"
						:p_enableCreate="false"
						p_required=true
					)
				div(class="form-group")
					label(class="required-label") Project Status
					div
						b-form-select(class="styled-input" size="sm" id="projectStatusId" v-model="d_recData.projectStatusId" :options="d_ref.projectStatuses" 
						value-field="id" text-field="name" required)
				div(class="form-group")
					label(:class="m_required('categoryId')?'required-label':''") Category
					div
						b-form-select(class="styled-input" size="sm" id="categoryId" v-model="d_recData.categoryId" :options="d_ref.categories"
						value-field="id" text-field="name" :disabled="d_recData.project")
				div(class="form-group")
					label(:class="m_required('marketSegmentId')?'required-label':''") Market Segment
					div
						b-form-select(class="styled-input" size="sm" id="marketSegmentId" v-model="d_recData.marketSegmentId" 
						:options="d_ref.selOpt(d_ref.marketSegments, d_recData.marketSegmentId)"
						value-field="id" text-field="name" )
				div(class="form-group")
					label(:class="m_required('contractTypeId')?'required-label':''") Contract Type
					div
						b-form-select(class="styled-input" size="sm" id="contractTypeId" v-model="d_recData.contractTypeId" 
						:options="d_ref.selOpt(d_ref.contractTypes, d_recData.contractTypeId)"
						value-field="id" text-field="name" )
				div(class="form-group")
					label(:class="m_required('projectSize')?'required-label':''") Project Size
					b-input-group(size="sm" prepend="sf"  )
						b-form-input(class="styled-input" id="projectSize" v-model="d_recData.projectSize" type="number" step="any")
				div(class="form-group")
					label(:class="m_required('value')?'required-label':''") Value
					b-input-group(size="sm" prepend="$"  )
						b-form-input(v-if="p_mode=='edit'||p_mode=='create'" class="styled-input" id="value" v-model="d_recData.value"  type="number" step="any" )
						b-form-input(v-else class="styled-input" id="valueText" v-model="c_value")
				div(class="form-group")
					label(:class="m_required('workInPlace')?'required-label':''") Work In Place
					b-input-group(size="sm" prepend="$"  )
						b-form-input(v-if="p_mode == 'edit'" class="styled-input" id="workInPlace" v-model="d_recData.workInPlace"   type="number"  step="any" :required="m_required('workInPlace')")
						b-form-input(v-else class="styled-input" id="workInPlaceText" v-model="c_workInPlace")
				div(class="form-group")
					label(:class="m_required('securedDate')?'required-label':''") Secured Date
					kt-tt-info(p_infoTxt="Contract has been signed and work is about to commence")
					b-form-input(size="sm" class="styled-input" id="securedDate" v-model="d_recData.securedDate" type="date"
					@change="d_ux.secdt=false")
				div(class="form-group")
					label(:class="m_required('constructionStartDate')?'required-label':''") Construction Start Date
					b-form-input(size="sm" class="styled-input" id="constructionStartDate" v-model="d_recData.constructionStartDate" type="date"  )
				div(class="form-group")
					label(:class="m_required('constructionCompletionDate')?'required-label':''") Construction Completion Date
					b-form-input(size="sm" class="styled-input" id="constructionCompletionDate" v-model="d_recData.constructionCompletionDate" type="date"  )
				div(class="form-group")
					label Days To Completion
					b-form-input(size="sm" class="styled-input" id="daysToCompletion" v-model="c_daysToCompletion" readonly type="number")
			template(v-slot:rec-form-center)
				div(class="form-group")
					label(:class="m_required('projectDetails')?'required-label':''") Project Details 
					b-input-group-prepend(class="px-0")
						b-input-group-text
							fa-icon(icon="list-ul")
						b-form-textarea(size="sm" class="styled-input" id="projectDetails" v-model="d_recData.projectDetails" rows=5)
				kt-custom-field(v-if="d_customFields.length>0" :p_mode="p_mode" p_prntRecKey="proj" :p_recData="d_recData.customData"  @change="d_recData.customData=$event")
			template(v-slot:rec-alt-view)
				kt-tasks(v-if="d_altViewKey=='TASK'" ref="kt-tasks" p_prntRecKey="proj" :p_prntRecInfo="c_recInfo" p_enableCUFilter=true)
				kt-attach(v-else-if="d_altViewKey == 'AT'" ref="kt-attach" p_prntRecKey="proj" :p_recInfo="c_recInfo")
				kt-business-insights(v-else-if="d_altViewKey == 'BI'" :p_recInfo="c_recInfo")
				kt-project-debrief(v-else-if="d_altViewKey == 'DB'" :p_recInfo="c_recInfo")


		b-modal(v-if="p_mode == 'create'" id="bm-new-proj-prmt" size="md" centered=true no-fade 
			hide-header-close no-close-on-backdrop no-close-on-esc  footer-class="flex-row-reverse"
			header-bg-variant="light" cancel-variant="outline-secondary"
			:ok-disabled="!d_recData.opportunityId"
			@ok="m_prmptOk"
			@cancel="m_prmptCancel")
			div(class="new-proj-prmt pb-4")
				p Projects are automatically created when Opportunities are awarded.
				p If you'd like to create a project manually for an Opportunity, select one below.
				p(class="small text-center text-muted mb-1") Note: Only Opportunities without a Project are available for selection.
				kt-select(ref="kts-new-proj-prmt" p_appEntKey="oppr" p_filterKey="noProject" class="mx-3" @change="m_prmptChg")

</template>

<script>

import {fn_fmtDt,fn_fmtMoney,kbdpAlert,fn_getHashId} from "@/utils/util.js";
import {fn_getRecordNo,fn_saveRecord} from "@/utils/api.js";
import {refData,userSettings} from "@/utils/ref-data.js";
import RecWrap from "@/components/RecWrap.vue";
import KTList from "@/components/Ctrl/KT-List.vue";
import KTTasks from "@/components/Ctrl/KT-Tasks.vue";
import KTAttach from "@/components/Ctrl/KT-Attach.vue";
import KTAddress from "@/components/Ctrl/KT-Address.vue";
import {fn_validate, fn_errorMsg} from "@/utils/appValidations.js";
import KTCustomField from "@/components/Ctrl/KT-CustomField.vue";


export default {
	name: "proj-rec",
	components: {
		'rec-wrap': RecWrap,
		'kt-list': KTList,
		'kt-tasks': KTTasks,
		'kt-attach': KTAttach,
		'kt-business-insights': () => import("@/components/Ctrl/KT-ProjectBusinessInsights.vue"),
		'kt-project-debrief': () => import("@/components/Ctrl/KT-ProjectDebrief.vue"),
		'kt-address': KTAddress,
		'kt-photo': () => import("@/components/Ctrl/KT-Photo.vue"),
		'kt-custom-field': KTCustomField,
		'kt-progress-status': () => import("@/components/Ctrl/KT-ProgressStatus.vue"),
	},
	created() {
		if (this.p_mode != 'create' && !this.p_recNo) {
			this.d_recNo = fn_getHashId(this);
		}
		else if (this.p_recNo) {
			this.d_recNo = this.p_recNo;
		}
		if (!this.d_recNo) {
			this.m_setDefaults();
		}
		this.d_projectNo=this.d_recData.projectNo;
		var usrOpts = userSettings.userOptions;
		console.log('usrOpts');
		console.log(usrOpts);
		this.d_readOnlyColumns=usrOpts['tableReadOnlyColumns']['kt-table-proj'];
		this.d_requiredColumns=usrOpts['tableRequiredColumns']['kt-table-proj'];
		this.d_requiredFields=this.d_requiredColumns.map(c=>{return c.field;});

	},
	mounted() {
		
		if (this.p_mode == 'create') {
			this.$bvModal.show('bm-new-proj-prmt');
		}
		this.d_readOnlyColumns.forEach(col=>{if(document.getElementById(col)) document.getElementById(col).disabled=true;});
	},
	data() {
		return {
			d_recNo: null,
			d_recData: {},
			d_rmndOpt: [], //Keep empty array here
			d_ref: refData,
			d_altViewKey: null,

			d_noClone: [
				'projectStatusId',
				'opportunity',
				'constructionStartDate',
				'constructionCompletionDate',
			],
			d_projectNo:null,
			d_validProjectNo: null,
			d_projectNoToolTip: null,
			d_ux: {
				dbrf: false, //Debrief Prompt
				secdt: false, //Secured Date Set
				awddt: false //Awarded Date Set
			},
			d_customFields:refData.customFields.filter(c=>(c.context=='proj')),
			d_savedRecord:null,
			d_currentFocus:null,
			d_readOnlyColumns:[],
			d_requiredColumns:[],
			d_requiredFields:[],
		};
	},
	props: {
		p_recNo: String,
		p_mode: String,
		p_isModal: Boolean,
	},
	computed: {
		c_workInPlace(){return this.d_recData.workInPlace?this.d_recData.workInPlace.toLocaleString('en'):null;},
		c_validProjectNo(){return this.d_validProjectNo},
		c_projectNoToolTip(){return this.d_projectNoToolTip},
		c_daysToCompletion(){
			var today = new Date();
			var completionDate= new Date(this.d_recData.constructionCompletionDate);
			return parseInt((completionDate - today) / (1000 * 60 * 60 * 24), 10); 
			}, 
		c_recInfo() {
			let rd = this.d_recData;
			return {
				Type:'project',
				Id: rd.projectId,
				No: rd.projectNo,
				Name: rd.projectName,
				projValue: rd.value,
				Team: [rd.internalContact, ...(rd.assignedTeamMembers || [])].filter(x => x != undefined)
			};
		},
		c_photoRec() {
			let rd = this.d_recData;
			return {
				photoId: rd.photoId,
				photoURL: rd.photoURL,
				photoName: rd.photoName
			};
		},
		c_statuses(){return [{id:10,name:"Launching"},{id:20,name:"Launched"},{id:30,name:"Completed"}];},
		c_value(){return fn_fmtMoney(this.d_recData.value);},
		c_startDate(){return fn_fmtDt(this.d_recData.constructionStartDate);},
		c_completionDate(){return fn_fmtDt(this.d_recData.constructionCompletionDate);},
	},
	methods: {
		m_processVoice(e){	
			document.getElementById(this.d_currentFocus).value=e;
		},
		m_saveFn() { //Called from  RecWrap, KTList, KTSelect
			let id = this.p_mode == 'edit' ? this.d_recData.projectId : null;
			this.d_recData.photoURL=null;
			this.d_savedRecord=true;
			return fn_saveRecord('project', id, this.d_recData);
		},
		m_addNew(key, fieldNm) {
			console.log('Project- Record - m_addNew -- Need Update');
		},

		m_setDefaults() {
			this.d_recData.projectStatusId = refData.projectStatuses.filter(x => x.name == 'Precon')[0].id;
			this.m_getProjectNo();
		},
		m_prmptChg(val) {
			this.$set(this.d_recData, 'opportunityId', val.opportunityId);
			this.$set(this.d_recData, 'opportunity', val);
			
		},
		m_prmptOk(e) {
			if (!this.d_recData.opportunityId) {
				e.preventDefault();
			}
			
			
		},
		m_prmptCancel() {
			window.sessionStorage.setItem('rec-wrap-save-cancel', true);
			this.$router.go(-1);
		},
		m_getProjectNo(){ 
		console.log('m_getProjectNo');
		fn_getRecordNo({context:'PROJ'}).then(resp=>{
			this.d_recData.projectNo=resp.recordData.recordNo;
			});
		},
		m_checkProjectNo(e){
		
		if(e==null){this.d_validProjectNo=false;
					return;
					}
					
		fn_validate('checkProjectNo', e).then(resp=>{
			var errorMessage=fn_errorMsg('checkProjectNo', e);
			if((resp.recordData)&&(resp.recordData.projectId != this.d_recData.projectId)) 
				{
				this.d_validProjectNo=false;
				this.d_projectNoToolTip=errorMessage;
				kbdpAlert.showErr(errorMessage);
				}
			else  {	
					this.d_validProjectNo=true;
					this.d_projectNoToolTip="";
				}			   
		}) 		
		},
		m_readOnly(col){return (this.d_readOnlyColumns&&this.d_readOnlyColumns.includes(col))?true:false;},
		m_required(col){return (this.d_requiredFields&&this.d_requiredFields.includes(col))?true:false;},	
	},
	watch: {
		p_mode(nv, ov) {
			if (nv == 'create' && !this.$route.params.clone) {
				this.timeout = setTimeout(() => {
					this.$bvModal.show('bm-new-proj-prmt');
				}, 100);
			}
		if (nv == 'create' || nv == 'edit'){	
			this.d_readOnlyColumns.forEach(col=>{if(document.getElementById(col)) document.getElementById(col).disabled=true;});
			}
		}
	}
};
</script>
<style scoped lang="less">
#bm-new-proj-prmt {
	.modal-footer {
		padding: 0.5em;
		button {
			padding: 0.2em 0.5em;
		}
	}
}
.milestoneClass {
	position: relative;
    top: 50px;
	text-align:left;
	width:33%;
}
.dataHighlight{
	color:#556E8D;
	font-size:20px;
}
.blueLabel{color:#4fa4ff;}
.styled-input,
.styled-select {
  width: 100%;
  border: 0px;
  border-radius: 0px;
  border-bottom: 1px solid #ddd;  //1px solid black;
}
.styled-input:disabled,
.styled-select:disabled {
  background-color: transparent;
  border-bottom: 1px solid #ddd;
}
.styled-input:focus,
.styled-select:focus {
  border-color: transparent;
  border-bottom: 1px solid #428bca;    //1px solid #428bca;
  box-shadow: none;
}
.raisedHeader{
	width:1130px;
	padding: 10px;
	background-color: white;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.19);
	border-radius: 8px;
}
.raisedHeader img {
	border-radius: 8px;
}
</style>